import React from 'react';

import {SidebarItem} from 'app/general/structures/SidebarItem';
import {PolicyProcessesSidebar} from 'app/policies/components/PolicyDetailPage/PolicyProcessesSidebar';
import {ProcedureProcessesSidebar} from 'app/procedures/components/ProcedureDetailPage/ProcedurePageSidebar/ProcedureProcessesSidebar';
import {getObjectProcessesURL} from 'app/urls';
import {getContentType} from 'app/utils/content-type';

import type {
  LeftSidebarElementType,
  LeftSidebarMenuButton,
  LeftSidebarPanelType,
} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {
  DetailPolicySerializedType,
  ProcedureHashidSerializedType,
} from 'sweet-types';

function ProcessesForPolicyPanelContent({
  object,
}: LeftSidebarPanelType<DetailPolicySerializedType>) {
  return <PolicyProcessesSidebar policy={object} />;
}

function ProcessesForProcedurePanelContent({
  object,
  legacyRefetch,
}: LeftSidebarPanelType<ProcedureHashidSerializedType>) {
  return (
    <ProcedureProcessesSidebar
      procedure={object}
      legacyRefetchData={() => {
        legacyRefetch();
        return Promise.resolve();
      }}
    />
  );
}

function ProcessesMenuButton<
  ItemType extends ProcedureHashidSerializedType | DetailPolicySerializedType
>({
  object,
  forceTooltipShow,
  hideTooltip,
  location,
  active,
}: LeftSidebarMenuButton<ItemType>) {
  const contentType = getContentType('proceduregroup');
  return (
    <SidebarItem
      title={contentType.pluralName}
      active={active}
      icon={contentType.icon}
      link={getObjectProcessesURL(object, location.search)}
      forceTooltipShow={forceTooltipShow}
      onClick={hideTooltip}
    />
  );
}

export const ProcessesForProcedureLeftSidebar: LeftSidebarElementType<ProcedureHashidSerializedType> =
  {
    Panel: ProcessesForProcedurePanelContent,
    MenuButton: ProcessesMenuButton,
    type: 'left',
    sidebarName: 'showProcesses',
  };

export const ProcessesForPolicyLeftSidebar: LeftSidebarElementType<DetailPolicySerializedType> =
  {
    Panel: ProcessesForPolicyPanelContent,
    MenuButton: ProcessesMenuButton,
    type: 'left',
    sidebarName: 'showProcesses',
  };
